import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PdfSettingsModel } from '../../models';

@Component({
  selector: 'rnpl-pdf-bottom-block',
  templateUrl: './pdf-bottom-block.component.html',
  styleUrls: ['./pdf-bottom-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfBottomBlockComponent {

  @Input() pdfSettings: PdfSettingsModel;

}
